// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import Content from '../../components/fundingSources/Content';
// eslint-disable-next-line import/no-cycle
import { deleteFundingSource, makePrimaryFundingSource } from '../../storage/actions/superAdmin';
import getFundingSourcesList from '../../utils/api/get/getFundingSourcesList';
import DashboardIcon from '../../components/dashboard/icons/DashboardIcon';

const FundingSources = ({ mainContainer, auth, ...props }) => {
  const context = useFoundingSourceContext(props);

  return (
    <div className="subpage-wrap subpage-wrap--admin subpage-wrap--funding">
      <div className="subpage-header">
        <h1 className="subpage-title">Payment Method</h1>
        <button
          type="button"
          className="subpage-btn subpage-btn--gold"
          aria-label="add payment method"
          onClick={() => {
            props.toggleModal(false, 'loader');
            props.toggleModal(true, 'addFundingSourceToDwollaBySuperAdmin');
          }}
        >
          <DashboardIcon name="plus" size={18} strokeWidth="2.5" />
          Add Funding Source
        </button>
      </div>
      <Content {...context} auth={auth} />
    </div>
  );
};

export const useFoundingSourceContext = ({
  toggleModal, isReload, deleteFundingSource, makePrimaryFundingSource,
}) => {
  const [fundingSources, setFundingSources] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const fetchData = async () => {
    setIsLoaded(false);
    try {
      const newFundingSourcesList = await getFundingSourcesList('all');
      setFundingSources(newFundingSourcesList);
    } finally {
      setIsLoaded(true);
    }
  };

  const handlerVerify = fundingSource => {
    toggleModal(true, 'verifyFundingSource', false, { fundingSource });
  };

  const handlerDelete = (fundingSourceId) => {
    deleteFundingSource(fundingSourceId);
  };

  const makePrimary = fundingSourceId => {
    makePrimaryFundingSource(fundingSourceId);
  };

  useEffect(() => {
    fetchData();
  }, [isReload]);

  return { fundingSources, isLoaded, handlerVerify, handlerDelete, makePrimary };
};

const mapDispatchToProps = {
  toggleModal,
  deleteFundingSource,
  makePrimaryFundingSource,
};

const mapStateToProps = (state) => ({
  isReload: state.applicationState.isReload,
  auth: state.auth,
});

export default connect(mapStateToProps, mapDispatchToProps)(FundingSources);
